module.exports = __webpack_public_path__ + "static/media/news-6.724b5ced.jpg";